import React from 'react';
import ReportForm from '../../Forms/Rechner/ReportForm';

const ReportPage: React.FC = () => {
  return (
    <div className="container">
      <div className="page-content-text">
        <p>
          Hier kann die Auswertung des Bu-Rechners heruntergeladen
          werden.
        </p>
      </div>
      <ReportForm />
    </div>
  );
};

export default ReportPage;
